
import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Merges Tailwind CSS classes with clsx/classnames functionality
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
